module.exports = __webpack_public_path__ + "images/emoji/raised_hand.d9d2a7cf22f3f6692655.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/raised_hand.png
// module id = MfdF
// module chunks = 24